import clsx from 'clsx';
import { useTranslation } from 'next-i18next/pages';
import Image, { ImageProps } from 'next/image';
import { useState } from 'react';
import { createPortal } from 'react-dom';

import { ReactComponent as Times } from '@pflegia/ui/icons/times.svg';
import { usePreventBackgroundScroll } from '@pflegia/ui/shared/modal/usePreventBackgroundScroll';

interface FullPageImageProps {
  image: ImageProps['src'];
  onDismiss: VoidFunction;
}

const FullPageImage: React.FC<FullPageImageProps> = ({ image, onDismiss }) => {
  const { t } = useTranslation('common');
  const [loading, setLoading] = useState(true);
  usePreventBackgroundScroll();

  return createPortal(
    <div className='z-modal fixed inset-0 grid place-items-center bg-gray-900/50 p-8' onClick={onDismiss}>
      <div className={clsx('relative h-3/4 w-3/4 p-8', loading && 'animate-pulse')}>
        <Image alt='' className='object-contain' fill onLoadingComplete={() => setLoading(false)} sizes='75vw' src={image} />
      </div>
      <button className='fixed top-8 right-8 p-2 text-white' type='button' onClick={onDismiss} aria-label={t('common:close')}>
        <Times title={t('common:close')} />
      </button>
    </div>,
    document.body,
  );
};

export default FullPageImage;
